import { createFileRoute } from "@tanstack/react-router";
import { V0 } from "@/components/V0";

function RouteComponent() {
  return <V0 />;
}

export const Route = createFileRoute("/_authenticated/v0/")({
  component: RouteComponent,
  staticData: { page: "engineering" },
});
